import { render, staticRenderFns } from "./Districts.vue?vue&type=template&id=98b644e4&scoped=true&"
import script from "./Districts.vue?vue&type=script&lang=js&"
export * from "./Districts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b644e4",
  null
  
)

export default component.exports